
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/avis-legal/condicions-utilitzacio-del-portal",
      function () {
        return require("private-next-pages/corporatiu/avis-legal/condicions-utilitzacio-del-portal/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/avis-legal/condicions-utilitzacio-del-portal"])
      });
    }
  